// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
'use strict';
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class RouteIDGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.ROUTE_ID_GROUP, null, pfixFieldSet);
    }
    getRouteId() {
        return this.GetValue(FieldsFactory.FIELD_ROUTE_ID);
    }
    setRouteId(routeID) {
        this.SetField(FieldsFactory.FIELD_ROUTE_ID, routeID);
    }
}
